import React, { useId } from 'react';

const FALLBACK_CURRENCIES = ['AED', 'AUD', 'CAD', 'CHF', 'CNY', 'EUR', 'GBP', 'HKD', 'INR', 'JPY', 'KWD', 'NZD', 'QAR', 'SAR', 'SGD', 'USD', 'ZAR'];
let currencies = FALLBACK_CURRENCIES;
try { currencies = Intl.supportedValuesOf?.('currency') || FALLBACK_CURRENCIES; } catch {}

export default function UnitOperatingSettingsFields({ value, onChange, disabled = false }) {
  const id = useId();
  const set = key => event => onChange({ ...value, [key]: event.target.value });
  const currency = String(value.operating_currency || '').trim().toUpperCase();
  const options = [...new Set([...currencies, ...(currency ? [currency] : [])])].sort();
  const inputClass = 'h-11 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-900 disabled:opacity-50';
  return <fieldset disabled={disabled} className="md:col-span-2 grid grid-cols-1 gap-3 rounded-lg border border-gray-200 p-3 md:grid-cols-2">
    <legend className="px-1 text-sm font-semibold">Unit operating settings</legend>
    <label className="space-y-1 text-sm" htmlFor={id + '-currency'}>
      <span className="block">Operating currency</span>
      <select id={id + '-currency'} value={currency} onChange={set('operating_currency')} className={inputClass}>
        <option value="">Select currency</option>
        {options.map(code => <option key={code} value={code}>{code}</option>)}
      </select>
      <span className="block text-xs text-gray-500">Currency used for this unit’s operating totals.</span>
    </label>
    <label className="space-y-1 text-sm" htmlFor={id + '-country'}>
      <span className="block">Country code</span>
      <input id={id + '-country'} value={value.country_code || ''} onChange={set('country_code')}
        placeholder="FR" maxLength={2} className={inputClass} />
    </label>
    <label className="space-y-1 text-sm" htmlFor={id + '-timezone'}>
      <span className="block">Timezone</span>
      <input id={id + '-timezone'} value={value.timezone || ''} onChange={set('timezone')}
        placeholder="Europe/Paris" list={id + '-timezones'} className={inputClass} />
      <datalist id={id + '-timezones'}>{['Europe/London', 'Europe/Paris', 'America/New_York', 'Asia/Dubai', 'UTC'].map(zone => <option key={zone} value={zone} />)}</datalist>
    </label>
    <label className="space-y-1 text-sm" htmlFor={id + '-locale'}>
      <span className="block">Locale</span>
      <input id={id + '-locale'} value={value.locale || ''} onChange={set('locale')}
        placeholder="fr-FR" list={id + '-locales'} className={inputClass} />
      <datalist id={id + '-locales'}>{['en-GB', 'fr-FR', 'en-US', 'de-DE', 'ar-AE'].map(locale => <option key={locale} value={locale} />)}</datalist>
      <span className="block text-xs text-gray-500">Controls number and date formatting.</span>
    </label>
    <label className="space-y-1 text-sm" htmlFor={id + '-tax'}>
      <span className="block">Default tax rate (%)</span>
      <input id={id + '-tax'} type="number" min="0" max="100" step="any"
        value={value.default_tax_rate ?? ''} onChange={set('default_tax_rate')} className={inputClass} />
      <span className="block text-xs text-gray-500">Enter a rate from 0 to 100.</span>
    </label>
  </fieldset>;
}
